import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {ActionContainerModel} from "../../../../../../../models/aggregates/alg/cc/action";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
  
@Injectable({providedIn: "root"})
export class ActionService extends BaseApiTemplateService<ActionContainerModel>{
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'actions';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'actions';
    this.httpClient = http;
  }
}